
import Apis from '@/Apis/_'
import ResponseApi from '../interfaces/FactoryResponse'

class ReservaDeSangue implements IReservaDeSangue {
  async getReservaDeSangue(solicitacaoId: string): Promise<ResponseApi> {
    const response = await Apis.Agendamento.AgendamentoMedicoBackofficeApi.getReservaDeSangue(solicitacaoId)
    return response
  }

  async putReservaDeSangue(params: any): Promise<ResponseApi> {
    const response = await Apis.Agendamento.AgendamentoMedicoBackofficeApi.putReservaDeSangue(params)
    return response
  }
}

interface IReservaDeSangue {
  getReservaDeSangue(solicitacaoId: string): Promise<ResponseApi>
  putReservaDeSangue(params: any): Promise<ResponseApi>
}

export {
  IReservaDeSangue,
  ReservaDeSangue,
}
